'use client';
const stylePropertyPrefixes = {
    margin: 'm',
    marginTop: 'mt',
    marginRight: 'mr',
    marginBottom: 'mb',
    marginLeft: 'ml',
    marginX: 'mx',
    marginY: 'my',
    padding: 'p',
    paddingTop: 'pt',
    paddingRight: 'pr',
    paddingBottom: 'pb',
    paddingLeft: 'pl',
    paddingX: 'px',
    paddingY: 'py',
    backgroundColor: 'bgc',
    visuallyHidden: 'visually-hidden',
    textAlign: 'text-align',
    textColor: 'text-color',
    textAllCaps: 'text-all-caps',
    fontWeight: 'font-weight',
    fontSize: 'text',
    fontFamily: 'font',
    fontSkin: 'font-skin',
    standardMode: 'standard-mode',
    darkMode: 'dark-mode',
    compactMode: 'compact-mode',
    loadingShimmer: 'loading-shimmer'
};
const styleValidProperties = new Set([
    "margin",
    "m",
    "marginTop",
    "mt",
    "marginRight",
    "mr",
    "marginBottom",
    "mb",
    "marginLeft",
    "ml",
    "marginX",
    "mx",
    "marginY",
    "my",
    "padding",
    "p",
    "paddingTop",
    "pt",
    "paddingRight",
    "pr",
    "paddingBottom",
    "pb",
    "paddingLeft",
    "pl",
    "paddingX",
    "px",
    "paddingY",
    "py",
    "backgroundColor",
    "bgc",
    "textAlign",
    "textAllCaps",
    "textColor",
    "fontWeight",
    "fontSize",
    "fontFamily",
    "fontSkin",
    "display",
    "standardMode",
    "darkMode",
    "compactMode",
    "overflow",
    "visuallyHidden",
    "loadingShimmer"
]);
const responsiveModifierSet = new Set([
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
]);
function isValidStyleProperty(t) {
    return styleValidProperties.has(t);
}
function isResponsiveModifier(t) {
    return responsiveModifierSet.has(t);
}
function getKey(t) {
    return isValidStyleProperty(t) ? stylePropertyPrefixes[t] || t : null;
}
const swanStyleObjectFitValues = [
    'cover',
    'contain',
    'none',
    'unset',
    'fill'
];
function swanStyleObjectFit(t) {
    return t ? `swan-image-fit-${t}` : null;
}

export { getKey, isResponsiveModifier, isValidStyleProperty, responsiveModifierSet, stylePropertyPrefixes, styleValidProperties, swanStyleObjectFit, swanStyleObjectFitValues };
